import PropTypes from 'prop-types';
import React from 'react';
import { formatTrackNumber } from '../../../../utils';
import * as Styled from './WaveformImage.styles';
var WaveformImage = function WaveformImage(_ref) {
  var _track$album, _track$album2;
  var clipped = _ref.clipped,
    track = _ref.track;
  var src = "https://content2.audionetwork.com/Preview/tracks/mp3/v5res/ANW".concat(((_track$album = track.album) === null || _track$album === void 0 ? void 0 : _track$album.number) || ((_track$album2 = track.album) === null || _track$album2 === void 0 ? void 0 : _track$album2.id), "/").concat(formatTrackNumber(track.albumTrackNumber), "_").concat(clipped ? 'y' : 'g', ".png");
  return /*#__PURE__*/React.createElement(Styled.Wrapper, null, /*#__PURE__*/React.createElement(Styled.WaveformImage, {
    clipped: clipped,
    src: src,
    alt: ""
  }));
};
WaveformImage.defaultProps = {
  clipped: false
};
WaveformImage.propTypes = {
  clipped: PropTypes.bool,
  track: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    waveformData: PropTypes.arrayOf(PropTypes.number),
    waveformImageUrl: PropTypes.string,
    type: PropTypes.string,
    album: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      number: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    albumTrackNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    duration: PropTypes.number
  }).isRequired
};
export default /*#__PURE__*/React.memo(WaveformImage);